import { Box, Typography } from '@mui/material';
import { BankTransferInstructions } from '../../interfaces/Checkout/BankTransferInstructions';

type InstructionRowProps = {
  label: string;
  value: string;
};

const InstructionRow = ({ label, value }: InstructionRowProps) => {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, width: '100%' }}
    >
      <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
        {label}:
      </Typography>
      <Typography sx={{ fontSize: '14px' }}>{value}</Typography>
    </Box>
  );
};

type BankTransferContentProps = {
  instructions: BankTransferInstructions;
};

export const BankTransferContent = ({
  instructions,
}: BankTransferContentProps) => {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%' }}
    >
      <InstructionRow label='Alıcı Adı' value={instructions.recipientName} />
      <InstructionRow label='IBAN' value={instructions.iban} />
      <InstructionRow label='Banka Adı' value={instructions.bankName} />
      <InstructionRow label='Şube' value={instructions.branch} />
      <InstructionRow label='Hesap No' value={instructions.accountNumber} />
    </Box>
  );
};
